import { CookiesConsent } from '../twig/components/CookiesConsent';
import { Carousel } from '../../views/ts/components/Carousel';
import { Collapse } from '../../views/ts/components/Collapse';
import { Dropdown } from '../../views/ts/components/Dropdown';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { LightGallery } from '../twig/components/LightGallery';
import { Header } from '../twig/components/Header';
import { RecentlyViewed } from '../twig/components/RecentlyViewed';
import { Share } from '../twig/components/Share';
import { SplashScreen } from '../twig/components/SplashScreen';
import { SubMenu } from '../twig/components/SubMenu';
import { TextClamp } from '../twig/components/TextClamp';
import { ViewSwitcher } from '../twig/components/ViewSwitcher';
import { Lists } from '../twig/components/Lists';
import { SingleArtist } from '../twig/pages/single-artist';
import { List } from '../twig/pages/single-list';
import { Search } from '../twig/pages/search';
import { BtnBack } from '../twig/components/BtnBack';
import { SingleProduct } from '../twig/pages/single-product';
import { Page } from '../twig/pages/page';
import { ArchiveProducts } from '../twig/pages/archive-product';
(new CookiesConsent()).init();
(new Carousel()).init();
(new Collapse()).init();
(new Dropdown()).init();
(new LazyLoader()).init();
(new LightGallery()).init();
(new Header()).init();
(new RecentlyViewed()).init();
(new Share()).init();
(new SubMenu()).init();
(new TextClamp()).init();
(new ViewSwitcher()).init();
(new SplashScreen()).init();
(new Lists()).init();
(new SingleArtist()).init();
(new List()).init();
(new Search()).init();
(new BtnBack()).init();
(new SingleProduct()).init();
(new Page()).init();
(new ArchiveProducts()).init();
